import React from 'react';
import { XCircleIcon } from 'lucide-react';
import { FadeIn } from './FadeIn';
export function PainPoints() {
  const painPoints = ['Tu hijo se frustra cuando intenta leer.', 'Sentís que probaste fichas, videos o ejercicios... pero nada parece funcionar.', 'Cada intento termina en tensión o discusiones.', 'Querés ayudarlo, pero no sabés qué hacer ni en qué orden.', 'Tenés materiales descargados pero ninguno forma un método real.', 'Te preocupa que pierda confianza porque siente que "no puede".'];
  return <section className="py-8 md:py-20 px-4 bg-gradient-to-br from-kid-purple/5 via-kid-pink/5 to-white relative overflow-hidden" data-id="element-267">
      <div className="max-w-4xl mx-auto relative z-10" data-id="element-268">
        <FadeIn data-id="element-269">
          <div className="text-center mb-6 md:mb-12" data-id="element-270">
            <h2 className="text-2xl md:text-3xl font-bold text-gray-900 mb-4 md:mb-6" data-id="element-271">
              ESTE SISTEMA ES PARA TI SI...
            </h2>
            <div className="w-24 h-1 bg-gradient-to-r from-kid-purple to-kid-pink mx-auto rounded-full" data-id="element-272"></div>
          </div>
        </FadeIn>

        <div className="w-full" data-id="element-273">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-3 md:gap-5" data-id="element-274">
            {painPoints.map((point, idx) => <FadeIn key={idx} delay={idx * 0.08} data-id="element-275">
                <div className="flex items-start gap-3 md:gap-4 p-4 md:p-5 rounded-xl bg-white shadow-sm border border-gray-200 border-l-[5px] border-l-kid-rose h-full" data-id="element-276">
                  <XCircleIcon className="w-5 h-5 text-kid-rose flex-shrink-0 mt-0.5" data-id="element-277" />
                  <p className="text-gray-700 font-semibold text-sm md:text-base leading-snug md:leading-relaxed" data-id="element-278">
                    {point}
                  </p>
                </div>
              </FadeIn>)}
          </div>
        </div>
      </div>
    </section>;
}